export default __webpack_public_path__ + "static/avatar7-4b41540c9336088f17261397c6ed9650.png";